<template>
    <div class="policies-container pb-50px flex justify-center items-center w-100%">
        <AppHeader title="Terms of use" :show-back="true" />

        <div class="w-100% p-20px">
            <div class="flex flex-col mt-30px items-center justify-center">
                <p class="color-#FFFFFF text-center lh-14px text-12px">
                    These Terms of Service ("Terms") govern your access to and use of the
                         {{ JSON.parse(parsed || '{}').AppName || 'Aishmin' }} website ("Website"), operated by      {{ JSON.parse(parsed || '{}').AppName || 'Aishmin' }} ("we", "us", or
                    "our"). By accessing or using the Website, you agree to be bound by
                    these Terms. If you do not agree to these Terms, you may not use the
                    Website.
                </p>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">1. Use of the Website</div>
                <p class="color-#fff lh-14px text text-10px">
                    1.1. You must be at least 18 years old to use the Website. By using
                    the Website, you represent and warrant that you are at least 18 years
                    old.
                </p>
                <p class="color-#fff lh-14px text text-10px">
                    1.2. You agree to use the Website in compliance with all applicable
                    laws, regulations, and these Terms.
                </p>
                <p class="color-#fff lh-14px text text-10px">
                    1.3. You are solely responsible for any content you post or transmit
                    through the Website, and you agree not to post or transmit any content
                    that is unlawful, harmful, defamatory, obscene, or otherwise
                    objectionable.
                </p>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">
                    2. Intellectual Property
                </div>
                <p class="color-#fff lh-14px text text-10px">
                    2.1. All content on the Website, including but not limited to text,
                    graphics, logos, images, and software, is the property of      {{ JSON.parse(parsed || '{}').AppName || 'Aishmin' }}
                    or its licensors and is protected by copyright and other intellectual
                    property laws.
                </p>
                <p class="color-#fff lh-14px text text-10px">
                    2.2. You may not modify, reproduce, distribute, or create derivative
                    works based on any content from the Website without our prior written
                    consent.
                </p>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">3. Privacy</div>
                <p class="color-#fff lh-14px text text-10px">
                    3.1. Your privacy is important to us. Please refer to our Privacy
                    Policy for information on how we collect, use, and disclose your
                    personal information.
                </p>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">
                    4. Disclaimer of Warranties
                </div>
                <p class="color-#fff lh-14px text text-10px">
                    4.1. The Website is provided on an "as is" and "as available" basis,
                    without any warranties of any kind, express or implied. We do not
                    warrant that the Website will be error-free or uninterrupted, or that
                    any defects will be corrected.
                </p>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">
                    5. Limitation of Liability
                </div>
                <p class="color-#fff lh-14px text text-10px">
                    5.1. To the fullest extent permitted by law, we will not be liable for
                    any indirect, incidental, special, consequential, or punitive damages
                    arising out of or relating to your use of the Website, even if we have
                    been advised of the possibility of such damages.
                </p>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">6. Indemnification</div>
                <p class="color-#fff lh-14px text text-10px">
                    6.1. You agree to indemnify and hold harmless      {{ JSON.parse(parsed || '{}').AppName || 'Aishmin' }} and its
                    affiliates, officers, directors, employees, and agents from any
                    claims, liabilities, damages, losses, or expenses arising out of or
                    relating to your use of the Website or violation of these Terms.
                </p>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">7. Governing Law</div>
                <p class="color-#fff lh-14px text text-10px">
                    7.1. These Terms are governed by and construed in accordance with the
                    laws of [insert jurisdiction], without regard to its conflict of laws
                    principles.
                </p>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">8. Changes to Terms</div>
                <p class="color-#fff lh-14px text text-10px">
                    8.1. We reserve the right to modify these Terms at any time. Any
                    changes will be effective immediately upon posting on the Website.
                    Your continued use of the Website after the posting of changes
                    constitutes your acceptance of such changes.
                </p>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">9. Contact Us</div>
                <p class="color-#fff lh-14px text text-10px">
                    9.1. If you have any questions about these Terms, please contact us at
                    support@sai.com. By using the Website, you acknowledge that you have
                    read, understood, and agree to be bound by these Terms.
                </p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import theme from '@/styles/theme';
import { AppHeader } from '@/components';
const parsed = localStorage.getItem('ai-chat-parsed')

// 政策和条款页面 - 不需要额外的数据
</script>

<style scoped lang="scss">
.policies-container {
    padding-bottom: 50px;
    background: v-bind('theme.colors.background');
    // min-height: 100vh;
}

.text {
    color: v-bind('theme.colors.textPrimary');
}

.info-item {
    padding: 10px;
    background-color: v-bind('theme.colors.backgroundQuaternary');
    margin-top: 10px;
}
</style>